import { render, staticRenderFns } from "./CoachManagerStatusFilters.vue?vue&type=template&id=71630154"
import script from "./CoachManagerStatusFilters.vue?vue&type=script&lang=js"
export * from "./CoachManagerStatusFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports